module.exports = __webpack_public_path__ + "media/images/svg-sprite-items/payment/payment-on-invoice-it-c59b7d8fd21359425d72dc571ef0ab81.svg";